var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"consult-bar-component",style:({
        background:
        ("linear-gradient(\n          to top,\n          " + (_vm.color.top) + ",\n          " + (_vm.color.bottom) + "\n        )")
     })},[_c('a',{staticClass:"consult-bar-btn",attrs:{"href":_vm.telHref}},[_vm._v("\n    电话咨询\n  ")]),(_vm.isWechat && _vm.wechatUrl !== '')?_c('a',{staticClass:"consult-bar-btn",attrs:{"href":_vm.wechatUrl}},[_vm._v("\n    微信咨询\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }